<template>
  <section class="privacy-page">
    <PageTitle title="PRIVACY POLICY"></PageTitle>
    <Privacy></Privacy>
    <Footer horizol="horizol" />
  </section>
</template>

<script>
import Privacy from "@/components/Privacy/Privacy";
import PageTitle from "@/components/PageTitle/PageTitle";
import Footer from "@/components/Footer/Footer";

export default {
  components: {
    Privacy,
    PageTitle,
    Footer
  }
};
</script>
